<div (click)="toggleExpand()" class="expand-text-container" [ngClass]="getClass()">
  <mat-icon>expand_more</mat-icon>
  <span translate="ADVANCED_OPTIONS"></span>
</div>

<div class="advanced-options-dropdown-container" [ngClass]="getClass()" [ngStyle]="getStyle()">
  <div class="tools-advanced-options-container">
    <ng-content></ng-content>
  </div>
</div>
